import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearAuthData } from "../utils/auth";

export default function Logout({ showToast }) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = () => {
      // Clear all authentication data using utility function
      clearAuthData();
      showToast("You have been successfully logged out.", "success");
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 1500);
    };

    // Auto-logout on component mount
    handleLogout();
  }, [navigate, showToast]);

  return (
    <>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        fontFamily: 'Segoe UI, sans-serif'
      }}>
        <div style={{ 
          textAlign: 'center',
          padding: '2rem',
          borderRadius: '12px',
          backgroundColor: '#f8fafc',
          boxShadow: '0 4px 16px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ color: '#0ea5e9', marginBottom: '1rem' }}>Logging Out...</h2>
          <p style={{ color: '#64748b' }}>You have been successfully logged out.</p>
          <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Redirecting to login page...</p>
        </div>
      </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </>
  );
}
